module.exports = __webpack_public_path__ + "static/media/upgrade.eea9565e.svg";